import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PixelService {

  private cdsBaseURL: string = "https://api.agroclimate.org"; // "https://cloud.agroclimate.org";
  public timeInterval: any;

  constructor(private http: HttpClient) { }

  public getPixelData(latitude, longitude, from, to, variables): Observable<any> {
    return this.http.get(this.cdsBaseURL + '/v2/pixel/pixel/lat/' + latitude + '/lon/' + longitude + '/from/' + from + '/to/' + to + '?var[eq]=avgT&var[eq]=totR&var[eq]=arid', { headers: { 'x-api-key': environment.apiKey } }).pipe(catchError(error => of(error)));
  }

  public getPixelHistData(latitude, longitude, from, to, variables): Observable<any> {
    return this.http.get(this.cdsBaseURL + '/v1/monitoring/climatology/lat/' + latitude + '/lon/' + longitude + '/from/' + from + '/to/' + to + '/interval/' + 'day' + '?var[eq]=avgT&var[eq]=totR&var[eq]=arid', { headers: { 'x-api-key': environment.apiKey } }).pipe(catchError(error => of(error)));
  }
}
